import { apiClient } from '@/lib/api';
import { ENDPOINTS } from '@/lib/api/endpoints';
import { PermissionsConfig, RolePermissions } from '../types/permission.types';
import {
  GRUPOS_DE_FUNCIONALIDAD,
  gruposDisponibles,
  llavesDeclaradas,
} from '../estructura-de-permisos';
import { techoParaEditarRoles } from '@/features/auth/tenant-modules';

class PermissionService {
  async getAll(): Promise<PermissionsConfig> {
    return apiClient.get(ENDPOINTS.PERMISSIONS);
  }

  async getMyPermissions(): Promise<{ permissions: string[]; menuItems: string[] }> {
    return apiClient.get(ENDPOINTS.PERMISSIONS_MY);
  }

  /** Lo que la empresa de la sesión tiene contratado (su techo), también para el PLATFORM_ADMIN. */
  async getCompanyModules(): Promise<{ tenantModules: string[] | null }> {
    return apiClient.get(ENDPOINTS.PERMISSIONS_COMPANY_MODULES);
  }

  async updateRole(
    role: string,
    permissions: string[],
    menuItems: string[]
  ): Promise<RolePermissions> {
    return apiClient.put(ENDPOINTS.PERMISSIONS_BY_ROLE(role), {
      permissions,
      menuItems,
      // Sólo lo que la pantalla MOSTRÓ: el servidor conserva el resto (navegador viejo, o un grupo
      // de un módulo que la empresa no tiene y que no se dibujó).
      clavesConocidas: llavesDeclaradas(
        gruposDisponibles(GRUPOS_DE_FUNCIONALIDAD, techoParaEditarRoles())
      ),
    });
  }

  async resetRole(role: string): Promise<RolePermissions> {
    return apiClient.post(ENDPOINTS.PERMISSIONS_RESET(role));
  }
}

export const permissionService = new PermissionService();
